<template>
  <div>
    <UserContact 
      :showDialog="dialogContact"
      :userId="authMod.user.user.id"
      :title="'Liên hệ của tôi'"
      @confirmed="onContactConfirmed"
      @cancelled="onContactCancelled"
    />
    <UserContact 
      :showDialog="dialogContact"
      :notUserId="authMod.user.user.id"
      :title="'Liên hệ khác'"
      @confirmed="onContactConfirmed"
      @cancelled="onContactCancelled"
    />
  </div>
</template>
<script>
  import UserContact from '@/views/admin/contacts/List';
  import { mapState } from 'vuex';
  export default {
    components: {
      UserContact
    },
    data: () => ({
      dialogContact: false
    }),
    computed: {
      ...mapState([
        'authMod'
      ])
    },
    methods: {
      showDialog(){
        this.dialogContact=true;
      },
      onContactConfirmed(item) {
        this.dialogContact = false;
      },
      onContactCancelled () {
        this.dialogContact = false;
      }
    }
  }
</script>